<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ (operation == 'new' ? 'Störung anlegen' : 'Störung bearbeiten') | mrTranslate }}</span>
    </div>
    <div class="header-actions">
      <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
        <cds-icon shape="times" />
      </a>
    </div>
  </header>

  <!-- <div id="stoerungWrapper"> -->
  <div class="clr-row nxm" style="height: calc(100% - 60px)">
    <div class="clr-col-12 clr-row nxm">
      <div class="clr-col-12 clr-col-lg-6">
        <!-- id="stoerungform" -->
        <form class="width100" clrForm [formGroup]="stoerungGroup" (ngSubmit)="onSubmit()">
          <clr-date-container>
            <label class="clr-col-md-4">{{ 'Datum der Störung' | mrTranslate }}</label>
            <input
              #dateModel
              class="clr-col-md-8"
              type="date"
              name="date"
              clrDate
              [ngModel]="dateControl | localeDate"
              (ngModelChange)="dateControl = localeDate.tosql($event)"
              [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
              [disabled]="stoerungGroup.disabled" />
          </clr-date-container>
          <clr-input-container>
            <label class="clr-col-md-4">{{ 'Zeit der Störung' | mrTranslate }}</label>
            <input class="clr-col-md-8" clrInput placeholder="00:00" type="time" name="time" formControlName="time" />
          </clr-input-container>

          <clr-datalist-container>
            <label class="clr-col-md-4 clr-control-label">{{ 'gemeldet durch' | mrTranslate }}</label>
            <input
              clrDatalistInput
              formControlName="gemeldetDurch"
              list="gemeldetDurchList"
              placeholder="{{ 'Name' | mrTranslate }}"
              name="gemeldetDurch"
              type="search"
              class="clr-col-md-8" />
            <datalist id="gemeldetDurchList">
              @for (name of gemeldetDurch; track name) {
                <option [value]="name"></option>
              }
            </datalist>
          </clr-datalist-container>

          <clr-datalist-container>
            <label class="clr-col-md-4 clr-control-label">{{ 'Art der Störung' | mrTranslate }}</label>
            <input
              clrDatalistInput
              formControlName="artDerStoerung"
              list="artDerStoerungList"
              placeholder="{{ 'Störung' | mrTranslate }}"
              name="artDerStoerung"
              type="search"
              class="clr-col-md-8" />
            <datalist id="artDerStoerungList">
              @for (name of stoerart; track name) {
                <option [value]="name"></option>
              }
            </datalist>
          </clr-datalist-container>

          <clr-radio-container clrInline class="parent" id="schaeden">
            <label class="clr-col-md-2">{{ 'Schäden' | mrTranslate }}?</label>
            <clr-radio-wrapper>
              <input type="radio" clrRadio name="schaeden" required [value]="true" formControlName="schaeden" />
              <label>{{ 'Ja' | mrTranslate }}</label>
            </clr-radio-wrapper>
            <clr-radio-wrapper>
              <input type="radio" clrRadio name="schaeden" required [value]="false" formControlName="schaeden" />
              <label>{{ 'Nein' | mrTranslate }}</label>
            </clr-radio-wrapper>
          </clr-radio-container>
          @if (stoerungGroup.value.schaeden) {
            <div class="indent">
              @if (stoerungGroup.errors?.['not-in-Direction']; as err) {
                <div class="clr-row nxm clr-col-auto">
                  <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
                    <clr-alert-item>
                      <span class="alert-text">
                        {{
                          'Der Startmeter muss ' + (err.upwards ? 'kleiner' : 'größer') + ' als der Endmeter sein'
                            | mrTranslate
                        }}
                      </span>
                    </clr-alert-item>
                  </clr-alert>
                </div>
              }
              @if ((typ_Line_Point | objtype) == 'line') {
                <div class="comboboxcontainer clr-form-control clr-row">
                  <label class="clr-col-md-4 clr-control-label">{{ 'Start- und Endmeter' | mrTranslate }}</label>
                  <div class="clr-col-md-8 clr-row nxm nxp">
                    <div
                      class="clr-control-container clr-col-6"
                      [ngClass]="{ 'clr-error': startmeter.errors?.min || startmeter.errors?.max }">
                      <div class="clr-input-wrapper">
                        <input
                          class="clr-input clr-col-md-6"
                          type="number"
                          [placeholder]="'von ' + (startm !== undefined ? startm : '0') + ' [m]'"
                          name="startmeter"
                          formControlName="startmeter" />
                        <cds-icon class="clr-validate-icon" shape="exclamation-circle" />
                      </div>
                      @if (startmeter.errors?.min || startmeter.errors?.max) {
                        <span class="clr-subtext">{{ 'Bitte einen Wert eingeben zwischen' | mrTranslate }} {{ startm }} - {{ endm - 1 }}</span>
                      }
                    </div>
                    <div
                      class="clr-control-container clr-col-6"
                      [ngClass]="{ 'clr-error': endmeter.errors?.min || endmeter.errors?.max }">
                      <div class="clr-input-wrapper">
                        <input
                          class="clr-input clr-col-md-6"
                          type="number"
                          [placeholder]="'bis ' + (endm !== undefined ? endm : '987') + ' [m]'"
                          name="endmeter"
                          formControlName="endmeter" />
                        <cds-icon class="clr-validate-icon" shape="exclamation-circle" />
                      </div>
                      @if (endmeter.errors?.min || endmeter.errors?.max) {
                        <span class="clr-subtext">{{ 'Bitte einen Wert eingeben zwischen' | mrTranslate }} {{ startm + 1 }} - {{ endm }}</span>
                      }
                    </div>
                  </div>
                </div>
              }
              <clr-datalist-container>
                <label class="clr-col-md-4 clr-control-label">{{ 'Prüfart' | mrTranslate }}</label>
                <input
                  clrDatalistInput
                  formControlName="pruefart"
                  list="pruefartList"
                  placeholder="{{ 'Prüfart' | mrTranslate }}"
                  name="pruefart"
                  type="search"
                  class="clr-col-md-8" />
                <datalist id="pruefartList">
                  @for (obj of pruefart; track obj) {
                    <option [value]="obj.val"></option>
                  }
                </datalist>
              </clr-datalist-container>
              <clr-datalist-container>
                <label class="clr-col-md-4 clr-control-label">{{ 'Mangel' | mrTranslate }}</label>
                <input
                  clrDatalistInput
                  formControlName="mangel"
                  list="mangelList"
                  placeholder="{{ 'Mangel' | mrTranslate }}"
                  name="mangel"
                  type="search"
                  class="clr-col-md-8" />
                <datalist id="mangelList">
                  @for (obj of mangel; track obj) {
                    <option [value]="obj.val"></option>
                  }
                </datalist>
              </clr-datalist-container>
              <clr-input-container clrInline>
                <label class="clr-col-md-4">{{ 'Umfang' | mrTranslate }}</label>
                <input class="clr-col-md-8" clrInput placeholder="4.1268..." name="umfang" formControlName="umfang" />
              </clr-input-container>
              <clr-datalist-container>
                <label class="clr-col-md-4 clr-control-label">{{ 'Einheit' | mrTranslate }}</label>
                <input
                  clrDatalistInput
                  formControlName="einheit"
                  list="einheitList"
                  placeholder="{{ 'Einheit' | mrTranslate }}"
                  name="einheit"
                  type="search"
                  class="clr-col-md-8" />
                <datalist id="einheitList">
                  @for (name of einheit; track name) {
                    <option [value]="name"></option>
                  }
                </datalist>
              </clr-datalist-container>
              <clr-checkbox-container>
                <label class="clr-col-md-4">{{ 'Betriebsgefahr' | mrTranslate }}</label>
                <clr-checkbox-wrapper class="clr-col-md-8">
                  <input
                    type="checkbox"
                    clrCheckbox
                    [value]="true"
                    name="betriebsgefahr"
                    formControlName="betriebsgefahr" />
                </clr-checkbox-wrapper>
              </clr-checkbox-container>
            </div>
          }

          <clr-radio-container clrInline class="parent">
            <label class="clr-col-md-2">{{ 'Ursache bekannt?' | mrTranslate }}</label>
            <clr-radio-wrapper>
              <input
                type="radio"
                clrRadio
                name="ursachebekannt"
                required
                [value]="true"
                formControlName="ursachebekannt" />
              <label>{{ 'Ja' | mrTranslate }}</label>
            </clr-radio-wrapper>
            <clr-radio-wrapper>
              <input
                type="radio"
                clrRadio
                name="ursachebekannt"
                required
                [value]="false"
                formControlName="ursachebekannt" />
              <label>{{ 'Nein' | mrTranslate }}</label>
            </clr-radio-wrapper>
          </clr-radio-container>
          @if (stoerungGroup.value.ursachebekannt) {
            <div class="indent">
              <div class="comboboxcontainer clr-form-control clr-row">
                <label class="clr-col-md-4 clr-control-label">{{ 'Ursache' | mrTranslate }}</label>
                <div class="clr-control-container clr-col-md-8">
                  <input
                    class="clr-input combobox"
                    placeholder="{{ 'Ursache' | mrTranslate }}"
                    type="search"
                    name="ursache"
                    formControlName="ursache"
                    list="ursacheList" />
                </div>
                <datalist id="ursacheList">
                  @for (name of ursache; track name) {
                    <option [value]="name"></option>
                  }
                </datalist>
              </div>
            </div>
          }
          <div id="massnahmen">
            <div id="addMassnahmeForm">
              <div class="clr-col-3">
                <div class="comboboxcontainer clr-form-control clr-row">
                  <div class="clr-control-container clr-col">
                    <input
                      class="clr-input combobox"
                      [attr.placeholder]="'Was' | mrTranslate"
                      type="search"
                      name="Was?"
                      [(ngModel)]="newMassnahme.was"
                      [ngModelOptions]="{ standalone: true }"
                      list="wasList" />
                  </div>
                  <datalist id="wasList">
                    @for (name of was; track name) {
                      <option [value]="name"></option>
                    }
                  </datalist>
                </div>
              </div>
              <div class="clr-col-3">
                <div class="comboboxcontainer clr-form-control clr-row">
                  <div class="clr-control-container clr-col">
                    <input
                      class="clr-input combobox"
                      [attr.placeholder]="'Wer' | mrTranslate"
                      type="search"
                      name="Wer?"
                      [(ngModel)]="newMassnahme.wer"
                      [ngModelOptions]="{ standalone: true }"
                      list="werList" />
                  </div>
                  <datalist id="werList">
                    @for (name of wer; track name) {
                      <option [value]="name"></option>
                    }
                  </datalist>
                </div>
              </div>
              <div class="clr-col-3">
                <input
                  class=""
                  type="date"
                  name="date"
                  clrDate
                  [ngModel]="newMassnahme.bisWann | localeDate"
                  (ngModelChange)="newMassnahme.bisWann = localeDate.tosql($event)"
                  [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
              </div>
              <div class="clr-col-2">
                <input
                  class="clr-col-12"
                  clrInput
                  placeholder="00:00"
                  name="time"
                  [(ngModel)]="newMassnahme.zeit"
                  [ngModelOptions]="{ standalone: true }"
                  type="time" />
              </div>
              <div class="clr-col-1">
                <button
                  type="button"
                  class="btn"
                  (click)="saveMassnahme(newMassnahme.type == 'insert' ? 'new' : 'edit')">
                  <cds-icon [shape]="newMassnahme.type == 'insert' ? 'plus' : 'check'" />
                </button>
              </div>
            </div>
            <clr-datagrid class="datagrid-compact">
              @if (operation == 'new') {
                <clr-dg-column style="width: 40px; min-width: 40px">
                  <cds-icon shape="times" />
                </clr-dg-column>
              }
              <clr-dg-column>{{ 'Was' | mrTranslate }}</clr-dg-column>
              <clr-dg-column>{{ 'Wer' | mrTranslate }}</clr-dg-column>
              <clr-dg-column>{{ 'bis Wann' | mrTranslate }}</clr-dg-column>
              <clr-dg-column style="width: 100px; min-width: 100px">{{ 'Zeit' | mrTranslate }}</clr-dg-column>

              @for (mass of massnahmen; track mass; let i = $index) {
                <clr-dg-row [ngClass]="{ selectedrow: newMassnahme.id && mass.id && mass.id == newMassnahme.id }">
                  @if (operation == 'new') {
                    <clr-dg-cell style="width: 40px; min-width: 40px">
                      <cds-icon shape="times" class="cursor-pointer" (click)="deleteMassnahme(i)" />
                    </clr-dg-cell>
                  }
                  @if (operation == 'edit') {
                    <clr-dg-action-overflow>
                      <button type="button" class="action-item" (click)="editMassRow(mass)">
                        {{ 'Bearbeiten' | mrTranslate }}
                      </button>
                    </clr-dg-action-overflow>
                  }
                  <clr-dg-cell>
                    {{ mass.was }}
                  </clr-dg-cell>
                  <clr-dg-cell>
                    {{ mass.wer }}
                  </clr-dg-cell>
                  <clr-dg-cell>
                    {{ mass.bisWann | tablePrettyPrint }}
                  </clr-dg-cell>
                  <clr-dg-cell style="width: 100px; min-width: 100px">
                    {{ mass.zeit }}
                  </clr-dg-cell>
                </clr-dg-row>
              }

              <clr-dg-footer>{{ massnahmen?.length ?? 0 }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>

            <button class="btn btn-primary" [disabled]="trial" type="submit">
              {{ (operation == 'new' ? 'Störung anlegen' : 'Störung speichern') | mrTranslate }}
            </button>
          </div>
        </form>
      </div>
      <div class="clr-col-12 clr-col-lg-6 clr-row nxm" [class.h-100]="history?.rows?.length > 0">
        @if (stoerungGroup.value.schaeden) {
          <div class="clr-col-12 margin-24-b" style="max-height: 50%">
            <app-preview-thumbnails
              [drag_drop]="true"
              [getBigFileFnc]="media.getApiFunctionMediaBig"
              (deleteFile)="deleteDoc($event)"></app-preview-thumbnails>
          </div>
        }
        @if (history?.rows?.length) {
          <div class="clr-col-12" style="height: 50%">
            <h3>{{ 'Historie' | mrTranslate }}</h3>
            @if (history?.columns) {
              <clr-datagrid class="datagrid-compact" style="height: calc(100% - 48px)">
                @for (column of history.columns; track column) {
                  <clr-dg-column
                    [clrDgField]="column.id"
                    [ngStyle]="{ 'min-width': column.id == 'username' ? '130px' : '4rem' }">
                    <ng-container
                      *clrDgHideableColumn="{
                        hidden: column.id | hideIDColumns: ['startmeter', 'endmeter', 'bild', 'rueckbilder'],
                      }">
                      {{ camelcase(column.id) | mrTranslate }}
                    </ng-container>
                  </clr-dg-column>
                }
                <clr-dg-row *clrDgItems="let row of history.rows" [ngClass]="{ selectedrow: row.omazsid == editId }">
                  <clr-dg-action-overflow>
                    <button class="action-item" (click)="editRow(row)">{{ 'Bearbeiten' | mrTranslate }}</button>
                    <button type="button" class="action-item" (click)="emailStoerung(row)">
                      {{ 'Email' | mrTranslate }}
                    </button>
                    @if (!row.rueckmeldetext) {
                      <button class="action-item" (click)="openRueckmeldung(row)">
                        {{ 'Rückmelden' | mrTranslate }}
                      </button>
                    }
                  </clr-dg-action-overflow>
                  @for (cell of history.columns; track cell) {
                    <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                  }
                </clr-dg-row>
                <clr-dg-footer>{{ history?.rows?.length ?? 0 }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
              </clr-datagrid>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
<!-- </div> -->

<clr-modal [(clrModalOpen)]="showRueckmeldung">
  <h3 class="modal-title">{{ 'Rückmeldung eintragen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form class="width100" clrForm [formGroup]="stoerungRueckGroup">
      <clr-date-container>
        <label class="clr-col-md-4">{{ 'Datum der Rückmeldung' | mrTranslate }}</label>
        <input class="clr-col-md-8" type="date" name="date" clrDate formControlName="termin" />
      </clr-date-container>
      <clr-select-container>
        <label class="clr-col-md-4">{{ 'Firma' | mrTranslate }}</label>
        <select class="clr-col-md-8" clrSelect formControlName="firma">
          @for (c of firmen; track c) {
            <option [ngValue]="+c.ID">{{ c.Firma }}</option>
          }
        </select>
      </clr-select-container>
      <clr-input-container>
        <label class="clr-col-md-4">{{ 'Rückmeldetext' | mrTranslate }}</label>
        <input class="clr-col-md-8" clrInput name="time" formControlName="rueckmeldetext" />
      </clr-input-container>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveRueckmeldung()">
      {{ 'Bemerkung speichern' | mrTranslate }}
    </button>
  </div>
</clr-modal>
